import { NotificationStyle } from './notifications.constants.js';

class Notification {
  constructor(body, options, id) {
    this.body = body;
    this.style = options.style || NotificationStyle.INFO;
    this.dismissible = !!options.dismissible;
    this.id = id;
    this.closeDelay = options.closeDelay;
    this.onClose = options.onClose;
    this.uniqueID = options.uniqueID;
  }
}

export { Notification };
